module.exports = __webpack_public_path__ + "img/n29.61ba3f7f.png";